export class AccessProfileModel {
    id?: number;
    name?: string;
    description?: string;
    created_at?: string;
    updated_at?: string;
    deleted_at?: string;
}